'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);

var _ = require('..');

var _MyStaffUserCard = require('./MyStaffUserCard.scss');var styles = _interopRequireWildcard(_MyStaffUserCard);
var _MyStaffUserForm = require('./MyStaffUserForm');var _MyStaffUserForm2 = _interopRequireDefault(_MyStaffUserForm);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Styles
var
MyStaffUserCard = function (_Component) {_inherits(MyStaffUserCard, _Component);
  function MyStaffUserCard(props) {_classCallCheck(this, MyStaffUserCard);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));_this.




















    handleEditClick = function () {return _this.setState(function (prevState) {return { isEdit: !prevState.isEdit };});};_this.
    handleCloseModal = function () {return _this.setState({ isOpenModal: false });};_this.
    handleOpenModal = function () {return _this.setState({ isOpenModal: true });};_this.
    handleDelete = function () {
      _this.props.deleteUser({ id: _this.props.id, token: _this.props.userToken });
      _this.handleCloseModal();
    };_this.

    renderMobileHeader = function () {var
      isEdit = _this.state.isEdit;var _this$props =






      _this.props,display_name = _this$props.display_name,phone_number = _this$props.phone_number,email = _this$props.email,profile_img = _this$props.profile_img,virtual_numbers = _this$props.virtual_numbers;
      var virtualNumber = (0, _get2.default)(virtual_numbers, '[0].virtual_number');

      return (
        _react2.default.createElement('div', { className: styles.headerWrapper },
          _react2.default.createElement('div', { className: styles.imageWrapper },
            _react2.default.createElement('img', { src: profile_img, alt: '' })),

          _react2.default.createElement('div', { className: styles.cardInfo },
            _react2.default.createElement('div', { className: styles.name }, display_name),
            _react2.default.createElement('div', { className: styles.contactsWrapper },
              !!phone_number && _react2.default.createElement('p', { className: styles.contacts },
                _react2.default.createElement('i', { className: 'icon icon-phone-my-staff' }),
                phone_number),

              !isEdit && !!virtualNumber && _react2.default.createElement('p', { className: styles.contacts },
                _react2.default.createElement('i', { className: 'icon icon-virtual-phone' }),
                virtualNumber),

              _react2.default.createElement('p', { className: styles.contacts },
                _react2.default.createElement('i', { className: 'icon icon-mail-new' }),
                email)))));





    };_this.state = { isEdit: false, isOpenModal: false };return _this;}MyStaffUserCard.prototype.componentWillReceiveProps = function componentWillReceiveProps(newProps) {if (this.state.isEdit && newProps.myStaff.error !== this.props.myStaff.error || this.state.isEdit && newProps.myStaff.editUserLoaded && newProps.myStaff.editUserLoaded !== this.props.myStaff.editUserLoaded) {this.handleEditClick();}};MyStaffUserCard.prototype.

  render = function render() {var _cx;var
    isEdit = this.state.isEdit;var _props =
















    this.props,translate = _props.translate,display_name = _props.display_name,phone_number = _props.phone_number,email = _props.email,virtual_numbers = _props.virtual_numbers,id = _props.id,profile_img = _props.profile_img,metaStaff = _props.metaStaff,isMobile = _props.isMobile,_props$delegated_prop = _props.delegated_properties,allowed = _props$delegated_prop.allowed,active = _props$delegated_prop.active,promotion = _props$delegated_prop.promotion,top_promotion = _props$delegated_prop.top_promotion;

    var virtualNumber = (0, _get2.default)(virtual_numbers, '[0].virtual_number');

    return (
      _react2.default.createElement('div', { className: styles.cardWrapper, key: id },
        _react2.default.createElement('div', { className: styles.cardInfoWrapper },
          isMobile && this.renderMobileHeader(),
          !isMobile && profile_img && _react2.default.createElement('div', { className: styles.imageWrapper },
            _react2.default.createElement('img', { src: profile_img, alt: '' })),

          _react2.default.createElement('div', { className: styles.cardInfo },
            !isMobile && _react2.default.createElement('div', { className: styles.name }, display_name),
            !isMobile && _react2.default.createElement('div', { className: styles.contactsWrapper },
              !!phone_number && _react2.default.createElement('p', { className: styles.contacts },
                _react2.default.createElement('i', { className: 'icon icon-phone-my-staff' }),
                phone_number),

              !isEdit && !!virtualNumber && _react2.default.createElement('p', { className: styles.contacts },
                _react2.default.createElement('i', { className: 'icon icon-virtual-phone' }),
                virtualNumber),

              _react2.default.createElement('p', { className: styles.contacts },
                _react2.default.createElement('i', { className: 'icon icon-mail-new' }),
                email)),


            _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.promotionWrapper, (_cx = {}, _cx[styles.editWrapper] = isEdit, _cx)) },









              !isEdit &&
              _react2.default.createElement('div', { className: styles.promotion },
                _react2.default.createElement('p', { className: styles.promotionName }, translate('myStaff', 'highlights')),
                _react2.default.createElement('p', { className: styles.promotionCount },
                  _react2.default.createElement('span', null, promotion.promoted || 0),
                  _react2.default.createElement('span', null, translate('myStaff', 'of')),
                  _react2.default.createElement('span', null, promotion.allowed || 0))),



              !isEdit &&
              _react2.default.createElement('div', { className: styles.promotion },
                _react2.default.createElement('p', { className: styles.promotionName }, translate('myStaff', 'remainingProperties')),
                _react2.default.createElement('p', { className: styles.promotionCount },
                  _react2.default.createElement('span', null, active || 0),
                  _react2.default.createElement('span', null, translate('myStaff', 'of')),
                  _react2.default.createElement('span', null, allowed || 0))),



              !isEdit &&
              _react2.default.createElement('div', { className: styles.promotion },
                _react2.default.createElement('p', { className: styles.promotionName }, translate('myStaff', 'op')),
                _react2.default.createElement('p', { className: styles.promotionCount },
                  _react2.default.createElement('span', null, top_promotion.promoted || 0),
                  _react2.default.createElement('span', null, translate('myStaff', 'of')),
                  _react2.default.createElement('span', null, top_promotion.allowed || 0))),



              isEdit &&
              _react2.default.createElement(_MyStaffUserForm2.default, {
                allowed: allowed || 0,
                promotion: promotion.allowed || 0,
                top_promotion: top_promotion.allowed || 0,
                metaStaff: metaStaff,
                id: id,
                editUserLoading: this.props.myStaff.editUserLoading,
                translate: translate,
                userToken: this.props.userToken,
                editUser: this.props.editUser })))),





        _react2.default.createElement('div', { className: styles.controlWrapper },
          _react2.default.createElement('p', { className: styles.control, onClick: this.handleEditClick },
            isEdit ? translate('myStaff', 'cancel') : translate('myStaff', 'edit')),

          _react2.default.createElement('p', null, '\xB7'),
          _react2.default.createElement('p', { className: styles.control, onClick: this.handleOpenModal }, translate('myStaff', 'delete'))),

        _react2.default.createElement(_.Modal, {
            isOpen: this.state.isOpenModal,
            className: styles.modal,
            onRequestClose: this.handleCloseModal },

          _react2.default.createElement('div', { className: styles.contentModalWrapper },
            _react2.default.createElement('p', { className: styles.titleModal },
              translate('myStaff', 'confirmRemovePart1') + ' ' + display_name + ' ' + translate('myStaff', 'confirmRemovePart2')),

            _react2.default.createElement('p', { className: styles.subTitleModal },
              translate('myStaff', 'actionCannotBeUndone')),

            _react2.default.createElement('div', { className: styles.buttonsModalWrapper },
              _react2.default.createElement('button', { className: styles.buttonHandleModal, onClick: this.handleDelete }, translate('myStaff', 'yesDelete')),
              _react2.default.createElement('button', { className: styles.buttonCloseModal, onClick: this.handleCloseModal }, translate('myStaff', 'close')))))));





  };return MyStaffUserCard;}(_react.Component);


MyStaffUserCard.propTypes = {
  translate: _propTypes2.default.func,
  editUser: _propTypes2.default.func,
  deleteUser: _propTypes2.default.func,
  display_name: _propTypes2.default.string,
  userToken: _propTypes2.default.string,
  delegated_properties: _propTypes2.default.object,
  properties: _propTypes2.default.object,
  metaStaff: _propTypes2.default.object,
  myStaff: _propTypes2.default.object,
  profile_img: _propTypes2.default.string,
  id: _propTypes2.default.string,
  phone_number: _propTypes2.default.string,
  email: _propTypes2.default.string,
  valid_until: _propTypes2.default.string,
  highlights: _propTypes2.default.string,
  remaining_properties: _propTypes2.default.number,
  virtual_numbers: _propTypes2.default.number,
  top: _propTypes2.default.number,
  isMobile: _propTypes2.default.number,
  days_diff: _propTypes2.default.number };exports.default =


MyStaffUserCard;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/MyStaffUserCard/MyStaffUserCard.js
// module id = 2691
// module chunks = 0